/**
 * <template-popup data-url="/pages/...">
 * Loads a page rendered with a sections template into a modal.
 * ModalDialog.show() calls loadContent() on the first `.template-popup` it finds.
 */
if (!customElements.get("template-popup")) {
  class TemplatePopup extends HTMLElement {
    loadContent() {
      if (this.loaded || this.loading) return;
      const url = this.dataset.url;
      if (!url) return;
      this.loading = true;

      fetch(url, { headers: { Accept: "text/html" } })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const main = doc.querySelector("#MainContent");
          if (!main) throw new Error("no-main");

          // Scripts do not run through innerHTML and the reveal-on-scroll
          // observer was set up on the initial DOM only : strip both.
          main.querySelectorAll("script").forEach((node) => node.remove());
          main.querySelectorAll(".scroll-trigger").forEach((node) => {
            node.classList.remove("scroll-trigger", "scroll-trigger--offscreen", "animate--slide-in", "animate--fade-in");
            node.removeAttribute("data-cascade");
          });

          this.innerHTML = main.innerHTML;
          this.loaded = true;
          this.classList.add("template-popup--loaded");
        })
        .catch(() => {
          const link = document.createElement("a");
          link.className = "link";
          link.href = url;
          link.target = "_blank";
          link.rel = "noopener";
          link.textContent = url;
          const wrapper = document.createElement("p");
          wrapper.className = "px-16 py-16 text-center";
          wrapper.append(link);
          this.replaceChildren(wrapper);
          this.loaded = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
  customElements.define("template-popup", TemplatePopup);
}
